import { OptionData } from "components/DesignSystem/Combobox/Combobox";
import { MultiValue, SingleValue } from "react-select";

export const getSelectedComboboxOption = (
  options: OptionData[],
  value: string | string[] | undefined,
  isMultiSelect?: boolean
): OptionData | OptionData[] | null => {
  if (isMultiSelect) {
    const selectedValues = Array.isArray(value) ? value : [];
    return options.filter((option) => selectedValues.includes(option.value));
  }

  const singleValue = Array.isArray(value) ? undefined : value;
  return options.find((option) => option.value === singleValue) || null;
};

export const resolveSelectedOptionLabel = (
  option: SingleValue<OptionData> | MultiValue<OptionData>
): string | null => {
  if (!option) return null;

  if (option instanceof Array) {
    const labels = option
      .map((item) => item.label)
      .filter((label): label is string => typeof label === "string");
    return labels.length > 0 ? labels.join(", ") : null;
  }

  return typeof option.label === "string" ? option.label : null;
};
